import { useEffect, useState } from "react"
import { isFullScreenActive } from "../../util"
import { ConsoleLogger } from "../../util/logger"

const logger = new ConsoleLogger()

export const useNetworkStatus = () => {
  const [status, setStatus] = useState<boolean>(true)
  
  useEffect(() => {
    async function listenNetworkChange() {
      logger.log("Network change to ", navigator.onLine ? "ONLINE" : "OFFLINE")

      // listen network change and update the status
      setStatus(navigator.onLine)

      // exit full screen in offline mode
      if (navigator.onLine === false) {
        if (isFullScreenActive()) await window.document.exitFullscreen()

      }
    }

    window.addEventListener("online", listenNetworkChange)
    window.addEventListener("offline", listenNetworkChange)

    return () => {
      window.removeEventListener("online", listenNetworkChange)
      window.removeEventListener("offline", listenNetworkChange)
    }
  }, [])

  return { isOnline: status, isOffline: !status }
}
